"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostEditAddress = void 0;
const Base_1 = require("./Base");
exports.PostEditAddress = {
    url: Base_1.URL_BASE + "/EditAddress",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostEditAddress.js.map